import React, { useEffect, useRef, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faCheck,
  faCheckSquare,
  faList,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { config } from "../config";
import AutoComplete from "../components/autoComplete";
import CustomModal from "../components/modal";
import numberToTamilRupees from "../helpers/numbertotamil";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import TaxBillPrint from "./taxbillprint";
import TaxBillPrintThermal from "./taxbillprintthermal";
import { Link } from "react-router-dom";
import ShareWhatsapp from "../helpers/shareWhatsapp";
import TranslateToTamil from "../helpers/wordtotamil";
import { nextReceiptNumber, validReceiptNumber } from "../helpers/receiptNumber";
const logo = require("../assets/images/logo.jpg");
function Taxbill() {
  const [mobilelist, setMobileList] = useState([]);
  const [inputValue, setInputValue] = useState({
    receiver: "பரமசிவம்",
    festival_type: "Sivarathiri",
  });
  const [amount, setAmount] = useState(0);
  const [receiptLoading, setReceiptLoading] = useState(true);
  const [formError, setFormError] = useState("");
  const [saving, setSaving] = useState(false);
  const saveInProgress = useRef(false);
  const [usersList, setUserList] = useState([]);
  const [shareWhatsapp, setShareWhatsapp] = useState(false);
  const [startPrint, setStartPrint] = useState(false);
  const [printType, setPrintType] = useState(() => localStorage.getItem('preferredPrintType') || 'A4');
  const rupeesRef = useRef();
  const nameRef = useRef();
  const addressRef = useRef();
  const removeDuplicates = async (array) => {
    return array.filter((item, index) => array.indexOf(item) === index);
  };

  const HandleGetMobileList = async () => {
    const list = await axios.get(`${config.BACKENDURL}getPhoneNumberList.php`);
    if (list.data.status === 200) {
      const duplicatesRemoved = await removeDuplicates(list.data.data);
      setMobileList(duplicatesRemoved);
    }
  };

  const GetReceiptNo = async () => {
    setReceiptLoading(true);
    setFormError("");
    try {
      const data = await axios.get(
        `${config.BACKENDURL}getTaxReceiptNoAndAmount.php`,
      );
      if (data.data.status !== 200 && data.data.status !== true) {
        throw new Error("Receipt request failed");
      }
      const receiptNumber = nextReceiptNumber(data.data.id);
      const word = numberToTamilRupees(
        data.data.amount[data.data.amount.length - 1],
      );
      setInputValue((previous) => ({
        ...previous,
        receipt_no: receiptNumber,
        amount_list: data.data.amount,
        amount: data.data.amount[data.data.amount.length - 1],
        amount_in_words: word,
      }));
      rupeesRef.current.value = word;
      setAmount(data.data.amount[data.data.amount.length - 1]);
    } catch (error) {
      setInputValue((previous) => ({ ...previous, receipt_no: undefined }));
      setFormError("ரசீது எண்ணை பெற முடியவில்லை. மீண்டும் முயற்சிக்கவும். (Unable to load a valid receipt number. Please retry.)");
    } finally {
      setReceiptLoading(false);
    }
  };

  useEffect(() => {
    HandleGetMobileList();
    GetReceiptNo();
  }, []);

  const HandleFormSubmit = async (e) => {
    e.preventDefault();
    if (saveInProgress.current) return;
    if (receiptLoading || !validReceiptNumber(inputValue.receipt_no)) {
      setFormError("சரியான ரசீது எண் தேவை. மீண்டும் முயற்சிக்கவும். (A valid receipt number is required. Please retry.)");
      return;
    }
    saveInProgress.current = true;
    setSaving(true);
    setFormError("");
    const submitData = {
      ...inputValue,
      name: nameRef.current.value,
      address: addressRef.current.value,
    };
    setInputValue(submitData);
    try {
      const result = await axios.post(
        `${config.BACKENDURL}insertNewTax.php`,
        submitData,
      );
      if (result.data.status !== 200) throw new Error("Save failed");
      if (!validReceiptNumber(result.data.receipt_no)) {
        throw new Error("Server did not confirm the saved receipt number");
      }
      setInputValue((previous) => ({
        ...previous,
        ...submitData,
        receipt_no: result.data.receipt_no,
      }));
      setShareWhatsapp(true);
    } catch (error) {
      setFormError("சேமிப்பை உறுதிப்படுத்த முடியவில்லை. பட்டியலில் சரிபார்க்கவும். (Save could not be confirmed. Check the entries list before trying again.)");
      saveInProgress.current = false;
      setSaving(false);
    }
  };

  const HandleDataSearch = async (mobile) => {
    const res = await axios.post(`${config.BACKENDURL}getDataByPhone.php`, {
      mobile,
    });
    if (res.data.status === 200) {
      if (res.data.data.length > 1) {
        setUserList(res.data.data);
      } else if (res.data.data.length === 1) {
        FillDetails(res.data.data[0], mobile);
      }
    }
  };

  const HandleInputs = (key, value) => {
    setInputValue((previous) => ({ ...previous, [key]: value }));
  };

  const FillDetails = (value, mobile) => {
    addressRef.current.value = value.address;
    nameRef.current.value = value.name;
    setInputValue((previous) => ({
      ...previous,
      user_id: value.user_id,
      name: value.name,
      address: value.address,
      mobile,
    }));
  };

  const AfterWhatsapp = () => {
    setStartPrint(true);
    setShareWhatsapp(false);
  };

  return (
    <div>
      {/* share whatsapp modal */}
      <CustomModal
        show={shareWhatsapp}
        bodyContent={
          <div>
            <p className="fw-bold" style={{ fontSize: 20 }}>
              <FontAwesomeIcon icon={faWhatsapp} size="lg" color="green" />{" "}
              வாட்ஸ்அப்பில் ரசீதை பகிரவும்{" "}
            </p>
          </div>
        }
        onClose={() => {
          AfterWhatsapp();
        }}
        onConfirm={() => {
          AfterWhatsapp();
          ShareWhatsapp(
            inputValue?.receipt_no,
            inputValue?.name,
            inputValue?.address,
            inputValue?.mobile,
            amount,
            inputValue?.amount_in_words,
            `${new Date().getDate()}-${new Date().getMonth()}-${new Date().getFullYear()}`,
            "SIVANRATHIRI TAX",
            "சிவன்ராத்திரி வரி",
          );
        }}
      />
      {/* user list modal */}
      <CustomModal
        show={usersList && usersList.length > 1}
        onClose={() => {
          setUserList([]);
        }}
        bodyContent={
          <div style={{ minWidth: 'min(700px, 95vw)', maxWidth: '900px', overflowX: 'hidden' }}>
            <h5 className="text-center fw-bold mb-3" style={{ color: '#333' }}>
              <FontAwesomeIcon icon={faUsers} className="me-2 text-primary" />
              பயனர்களை தேர்ந்தெடுக்கவும்
            </h5>
            <div className="d-flex fw-bold text-secondary border-bottom pb-2 mb-2 px-2" style={{ fontSize: '0.85rem' }}>
              <div style={{ flex: '1' }}>பெயர் (Name)</div>
              <div style={{ flex: '1' }}>முகவரி (Address)</div>
              <div style={{ width: '80px', flexShrink: 0 }} className="text-center">தேர்வு (Select)</div>
            </div>
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {usersList.map((item, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center p-3 mb-2 rounded-3 border"
                  style={{
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    backgroundColor: '#fff',
                    borderColor: '#e0e0e0',
                  }}
                  onClick={() => {
                    FillDetails(item, item.mobile);
                    setUserList([]);
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#e8f5e9';
                    e.currentTarget.style.borderColor = '#4caf50';
                    e.currentTarget.style.transform = 'scale(1.01)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#fff';
                    e.currentTarget.style.borderColor = '#e0e0e0';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  <div className="fw-bold text-dark" style={{ flex: '1', fontSize: '0.95rem' }}>
                    {item.name}
                  </div>
                  <div className="text-muted" style={{ flex: '1', fontSize: '0.9rem' }}>
                    {item.address}
                  </div>
                  <div style={{ width: '80px', flexShrink: 0 }} className="text-center">
                    <button
                      className="btn btn-sm btn-success rounded-pill px-3 fw-bold shadow-sm"
                      onClick={(e) => {
                        e.stopPropagation();
                        FillDetails(item, item.mobile);
                        setUserList([]);
                      }}
                    >
                      தேர்வு
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        }
      />
      <div className="container mt-0 pt-1 d-flex flex-wrap justify-content-between gap-2">
        <Link to="/" className="btn btn-sm btn-danger py-1 px-2">
          <FontAwesomeIcon icon={faArrowLeft} /> Back
        </Link>
        <Link to="/tax/list" className="btn btn-sm btn-success py-1 px-2">
          Tax List <FontAwesomeIcon icon={faList} />
        </Link>
      </div>
      {receiptLoading && <p role="status">ரசீது எண் பெறப்படுகிறது… (Loading receipt number…)</p>}
      {formError && (
        <div role="alert" className="alert alert-danger">
          {formError}
          {!validReceiptNumber(inputValue.receipt_no) && !receiptLoading && (
            <button type="button" className="btn btn-outline-danger ms-2" onClick={GetReceiptNo}>மீண்டும் முயற்சி (Retry)</button>
          )}
        </div>
      )}
      <form autoComplete="off"
        onSubmit={(e) => HandleFormSubmit(e)}
        className="form_validate mt-2 container-fluid px-2"
        id="form"
      >
        <div className="bg-white rounded-4 mx-auto p-3 shadow-lg w-100 mb-4" style={{ maxWidth: '800px' }}>
          <div className="d-none d-md-block text-center mb-2">
            <p className="text-danger fw-bold fs-5 mb-0">உ</p>
          </div>
          <div className="d-none d-md-flex flex-column align-items-center justify-content-center mb-3">
            <img src={logo} alt="Temple Logo" height="80" width="80" className="mb-2 shadow-sm rounded-circle" />
            <div className="text-center">
              <h6 className="text-danger fw-bold mb-1" style={{ fontSize: '0.8rem' }}>
                ஸ்ரீ மஹா கணபதி அனுக்ரஹம் | ஸ்ரீ சிவகாமியம்மன் சமேத ஸ்ரீ ஆலடீஸ்வரன் துணை
              </h6>
              <h3 className="fw-bold text-success mb-1" style={{ fontSize: '1.2rem' }}>
                ஸ்ரீ ஆலடி ஈஸ்வரர் சமேத சிவகாமியம்மாள் திருக்கோவில்
              </h3>
              <p className="text-dark fw-light mb-0" style={{ fontSize: '0.9rem' }}>
                <span className="fw-bold">ஈஞ்சார்</span>, சிவகாசி மேற்கு , விருதுநகர் - 626124
              </p>
            </div>
          </div>
          <div className="text-center border-top border-bottom border-primary py-2 mb-3 bg-light rounded">
            <h4 className="text-primary fw-bold mb-0" style={{ fontSize: '1.15rem' }}>
              சிவன்ராத்திரி {new Date().getFullYear()} வரி ரசீது
            </h4>
          </div>
          
          <div className="d-flex justify-content-between align-items-center bg-light p-3 rounded-3 mb-4 shadow-sm border">
            <div>
              <span className="text-muted d-block" style={{ fontSize: '0.8rem' }}>ரசீது எண் (Receipt No)</span>
              <span className="fw-bold text-dark fs-5">{inputValue?.receipt_no}</span>
            </div>
            <div className="text-end">
              <span className="text-muted d-block" style={{ fontSize: '0.8rem' }}>தேதி (Date)</span>
              <span className="fw-bold text-dark fs-5">{`${new Date().getDate()}-${new Date().getMonth() + 1}-${new Date().getFullYear()}`}</span>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="mobile" className="form-label fw-bold text-dark fs-6 mb-1">செல் (Mobile) <span className="text-danger">*</span></label>
              <AutoComplete
                options={mobilelist}
                inputClassName={"form-control form-control-lg p-3 fs-5 shadow-sm border-secondary"}
                optionClass={"w-100"}
                placeholder={"வரி செலுத்துபவர் செல்"}
                onChange={(value) => { HandleDataSearch(value); }}
                onInputChange={(data) => {
                  if (data.length === 15) { HandleDataSearch(data); return true; }
                  if (inputValue?.mobile && inputValue?.mobile.length === 10 && mobilelist.includes(inputValue?.mobile)) {
                    FillDetails({ user_id: null, name: "", address: "" }, data);
                  }
                  HandleInputs("mobile", data);
                }}
                required={true}
                minLength={10}
              />
              <ul id="users_list_mobile" className="datalistMobile"></ul>
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="name" className="form-label fw-bold text-dark fs-6 mb-1">பெயர் (Name) <span className="text-danger">*</span></label>
              <input autoComplete="off"
                type="text"
                ref={nameRef}
                className="form-control form-control-lg p-3 fs-5 shadow-sm border-secondary"
                id="name"
                placeholder="வரி செலுத்துபவர் பெயர்"
                defaultValue={inputValue?.name}
                required
                onBlur={async (e) => {
                  const tamil = await TranslateToTamil(e.target.value);
                  if (tamil) { HandleInputs("name", tamil); nameRef.current.value = tamil; }
                }}
                readOnly={mobilelist.includes(inputValue?.mobile)}
              />
              <ul id="users_list" className="datalist"></ul>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-12 mb-2">
              <label htmlFor="address" className="form-label fw-bold text-dark fs-6 mb-1">முகவரி (Address) <span className="text-danger">*</span></label>
              <textarea autoComplete="off"
                ref={addressRef}
                className="form-control form-control-lg p-3 fs-5 shadow-sm border-secondary"
                id="address"
                rows="2"
                placeholder="வரி செலுத்துபவர் முகவரி"
                defaultValue={inputValue?.address}
                onBlur={async (e) => {
                  const tamil = await TranslateToTamil(e.target.value);
                  if (tamil) { HandleInputs("address", tamil); addressRef.current.value = tamil; }
                }}
                required
                readOnly={mobilelist.includes(inputValue?.mobile)}
              ></textarea>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-12 mb-2">
              <label htmlFor="amount_in_words" className="form-label fw-bold text-dark fs-6 mb-1">ரூபாய் எழுத்துக்களில் (Amount in words)</label>
              <input autoComplete="off"
                ref={rupeesRef}
                type="text"
                className="form-control form-control-lg p-3 fs-5 shadow-sm bg-light text-primary fw-bold"
                placeholder="ரூபாய்"
                id="amount_in_words"
                readOnly
              />
            </div>
          </div>

          <div className="row mb-2">
            <div className="col-12 col-md-6 mb-2">
              <label className="form-label fw-bold text-dark fs-6 mb-1">வரி தொகை (Tax Amount) <span className="text-danger">*</span></label>
              <div className="d-flex flex-wrap gap-2">
                {inputValue?.amount_list?.map((items, index) => (
                  <React.Fragment key={index}>
                    <input
                      type="radio"
                      className="btn-check"
                      name="amount"
                      id={`tax-${index}`}
                      value={items}
                      autoComplete="off"
                      checked={items === amount ? "checked" : null}
                      onChange={(e) => {
                        const word = numberToTamilRupees(e.target.value);
                        setInputValue((previous) => ({ ...previous, amount: e.target.value, amount_in_words: word }));
                        rupeesRef.current.value = word;
                        setAmount(e.target.value);
                      }}
                    />
                    <label className={`btn btn-lg ${items === amount ? 'btn-warning' : 'btn-outline-warning text-dark'} fw-bold fs-5 shadow-sm flex-fill`} htmlFor={`tax-${index}`}>
                      ₹ {items}
                    </label>
                  </React.Fragment>
                ))}
              </div>
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="receiver_name" className="form-label fw-bold text-dark fs-6 mb-1">வசூலிப்பவர் (Receiver)</label>
              <div className="input-group input-group-lg shadow-sm">
                <span className="input-group-text bg-secondary text-white fw-bold border-secondary fs-5 px-3">
                  <FontAwesomeIcon icon={faUsers} />
                </span>
                <input autoComplete="off"
                  type="text"
                  className="form-control form-control-lg p-3 fs-5 border-secondary bg-light"
                  id="receiver_name"
                  value={inputValue?.receiver}
                  placeholder="வசூலிப்பவர்"
                  required
                  readOnly
                />
              </div>
            </div>
          </div>

          <div className="mt-1 pt-3 border-top border-2 border-light">
            <div className="d-flex justify-content-center mb-3">
              <div className="btn-group w-100 shadow-sm" role="group">
                <input autoComplete="off" type="radio" className="btn-check" name="printType" id="printA4" value="A4" checked={printType === 'A4'} onChange={() => { setPrintType('A4'); localStorage.setItem('preferredPrintType', 'A4'); }} />
                <label className="btn btn-outline-success p-2 fw-bold" htmlFor="printA4">A4 Print</label>

                <input autoComplete="off" type="radio" className="btn-check" name="printType" id="printThermal" value="Thermal" checked={printType === 'Thermal'} onChange={() => { setPrintType('Thermal'); localStorage.setItem('preferredPrintType', 'Thermal'); }} />
                <label className="btn btn-outline-success p-2 fw-bold" htmlFor="printThermal">Thermal Print</label>
              </div>
            </div>
            <div className="text-center mt-2">
              <button disabled={receiptLoading || !validReceiptNumber(inputValue.receipt_no) || saving} type="submit" className="btn btn-success p-3 fs-4 fw-bold rounded-pill shadow-lg w-100 d-md-none d-flex align-items-center justify-content-center">
                சமர்ப்பிக்க (Submit) <FontAwesomeIcon icon={faCheck} className="ms-3 fs-3" />
              </button>
              <button disabled={receiptLoading || !validReceiptNumber(inputValue.receipt_no) || saving} type="submit" className="btn btn-success p-3 fs-4 fw-bold rounded-pill shadow-lg d-none d-md-inline-flex align-items-center justify-content-center px-5" style={{ minWidth: '350px' }}>
                சமர்ப்பிக்க (Submit) <FontAwesomeIcon icon={faCheck} className="ms-3 fs-3" />
              </button>
            </div>
          </div>
        </div>
      </form>

      {startPrint && printType === 'A4' && (
        <TaxBillPrint
          name={inputValue?.name}
          address={inputValue?.address}
          amount={amount}
          amount_in_words={inputValue?.amount_in_words}
          mobile={inputValue?.mobile}
          receiptno={inputValue?.receipt_no}
          receiver={inputValue?.receiver}
          date={`${new Date().getDate()}-${
            new Date().getMonth() + 1
          }-${new Date().getFullYear()}`}
          festival_type={inputValue?.festival_type}
          AfterPrintClose={() => window.location.reload()}
        />
      )}
      {startPrint && printType === 'Thermal' && (
        <TaxBillPrintThermal
          name={inputValue?.name}
          address={inputValue?.address}
          amount={amount}
          amount_in_words={inputValue?.amount_in_words}
          mobile={inputValue?.mobile}
          receiptno={inputValue?.receipt_no}
          receiver={inputValue?.receiver}
          date={`${new Date().getDate()}-${
            new Date().getMonth() + 1
          }-${new Date().getFullYear()}`}
          festival_type={inputValue?.festival_type}
          AfterPrintClose={() => window.location.reload()}
        />
      )}
    </div>
  );
}

export default Taxbill;
